import React, { Component } from "react";
import style from "./PercentageCircle.module.scss";

// Taken from http://circle.firchow.net

class PercentageCircle extends Component {
  render() {
    return (
      <div className={style.c100 + " " + style["p" + this.props.percentage] + " " + style[this.props.color]}>
        <span className={style.smallDescriptionText}>{this.props.descriptionText}</span>
        <span className={style.percentageText}>{this.props.percentage}%</span>
        <div className={style.slice}>
          <div className={style.bar}></div>
          <div className={style.fill}></div>
        </div>
      </div>
    );
  }
}

export default PercentageCircle;
